/**
 * Recharts' default bar tooltip cursor is a noticeably dark band; use a light tint.
 */
export const DASHBOARD_BAR_TOOLTIP_CURSOR = {
  fill: 'var(--gray-100)',
  opacity: 0.22,
} as const

/** Default bar fill for dashboard period charts (Operations / Performance style). */
export const DASHBOARD_BAR_FILL_DEFAULT = 'var(--blue-400)'

/** Highlight fill for the current period bar. */
export const DASHBOARD_BAR_FILL_CURRENT = 'var(--orange-300)'

export function computeDashboardPeriodBarYAxisWidth(
  ticks: number[],
  formatTick: (value: number) => string,
  min = 48,
  max = 84,
): number {
  if (!ticks.length) return min
  const maxLen = Math.max(...ticks.map((t) => formatTick(t).length))
  return Math.min(max, Math.max(min, 10 + maxLen * 7.5))
}
